import React from 'react';
import useFeedbackStore  from './FeedbackStore';
import './FeedbackPanel.css';

const FeedbackPanel = () => {
  const { messages, isHistoryVisible } = useFeedbackStore();

  if (!isHistoryVisible || messages.length === 0) {
    return null;
  }

  return (
    <div className="feedback-wrapper">
      <div className="feedback-history">
        <h3>Message Log</h3>
        {[...messages].reverse().map((entry) => ( // Ya no necesitamos el índice 'i'
          // ✅ Usamos el ID único del mensaje como key.
          <div key={entry.id} className={`feedback-entry feedback-${entry.type}`}>
            <span dangerouslySetInnerHTML={{ __html: entry.message }} />
            <small className="timestamp">[{entry.time}]</small>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(FeedbackPanel);
